import { NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MdbButtonModule, MdbModalRef, MdbModalService, MdbOptionModule, MdbSelectModule } from 'mdb5-adapted';
import { SubmenuModel } from 'src/app/core/models/submenu.model';
import { ClientDetailsService } from 'src/app/core/rest-services/client-details.service';
import { LoadSpinnerService } from 'src/app/shared/loaders/spinner/loadspinner.service';

import { LmsModalFrameComponent } from '@lmsSharedUI';

@Component({
    selector: 'app-sub-menu-dialog',
    templateUrl: './sub-menu-dialog.component.html',
    styleUrls: ['./sub-menu-dialog.component.scss'],
    standalone: true,
    imports: [LmsModalFrameComponent, FormsModule, ReactiveFormsModule, NgIf, MdbSelectModule, NgFor,
      MdbOptionModule, MdbButtonModule]
})
export class SubMenuDialogComponent {
  submenuForm: FormGroup;
  submenuModel: SubmenuModel = new SubmenuModel();
  submitted = false;
  jobTitles: any;
data: any;
  constructor(
    private dialogRef: MdbModalRef<SubMenuDialogComponent>,
    private formBuilder: FormBuilder,
    private cs: ClientDetailsService,
    public dialog: MdbModalService,
    private loadingService: LoadSpinnerService) {

    this.cs.getAllJobTitles().subscribe((res) => {
      this.jobTitles = res;
      if (this.data) {
        this.submenuModel = this.data;
        const activeRoles: any[] = [];

        for (const b of this.data.submenusRoles) {
          const jobTitleId = b.jobTitle.id;
          const index = this.jobTitles.findIndex(
            (x: { id: any }) => x.id === jobTitleId
          );
          activeRoles.push(this.jobTitles[index]);
        }

        this.submenuModel.userRoles = activeRoles;
      }
    });
  }

  ngOnInit(): void {
    this.submitted = true;

    this.submenuForm = this.formBuilder.group({
      submenu: [this.submenuModel.submenu],
      component: [this.submenuModel.component],
      userRoles: [this.submenuModel.userRoles],
    });
  }

  async saveChanges(submenu: any) {
    this.dialogRef.close(submenu);
  }

  close() {
    this.dialogRef.close();
  }
}
